import {
    CREATE_USERFORM_WAREHOUSE_STYLE,
    CREATE_WAREHOUSE_STYLE_FAILURE,
    CREATE_WAREHOUSE_STYLE_REQUEST,
    CREATE_WAREHOUSE_STYLE_SUCCESS,
    DELETE_WAREHOUSE_STYLE_FAILURE,
    DELETE_WAREHOUSE_STYLE_REQUEST,
    DELETE_WAREHOUSE_STYLE_SUCCESS,
    FETCH_ALL_WAREHOUSE_STYLE_FAILURE,
    FETCH_ALL_WAREHOUSE_STYLE_REQUEST,
    FETCH_ALL_WAREHOUSE_STYLE_SUCCESS,
    FETCH_BY_ID_WAREHOUSE_STYLE_FAILURE,
    FETCH_BY_ID_WAREHOUSE_STYLE_REQUEST,
    FETCH_BY_ID_WAREHOUSE_STYLE_SUCCESS,
    FETCH_WAREHOUSE_STYLE_INVOICE_FAILURE,
    FETCH_WAREHOUSE_STYLE_INVOICE_REQUEST,
    FETCH_WAREHOUSE_STYLE_INVOICE_SUCCESS,
    NAVIGATE_WAREHOUSE_STYLE,
    NAVIGATE_WAREHOUSE_STYLE_DETAILS,
    NAVIGATE_WAREHOUSE_STYLE_PRINT,
    RESET_WAREHOUSE_STYLE_INVOICE,
    RESET_WAREHOUSE_STYLE_USERFORM,
    UPDATE_WAREHOUSE_STYLE_FAILURE,
    UPDATE_WAREHOUSE_STYLE_REQUEST,
    UPDATE_WAREHOUSE_STYLE_SUCCESS,
    WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_TAB
} from "./warehouseStyle.actionType";


export const WAREHOUSE_STYLE = 'wareHouseStyle';

let initialState = {
    loading: false,
    warehouseStyleData: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        // fldFromDate: new Date(),
        // fldToDate: new Date().setDate(new Date().getDate() + 30),
    },
    detailsId: {},
    errorMessage: '',
    warehouseStyleSelectedValue: null,
    isWarehouseStyle: false,
    activeKey: 1,
    warehouseStyleInvoiceData: [],
}

export let warehouseStyleReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_WAREHOUSE_STYLE_REQUEST:
        case FETCH_BY_ID_WAREHOUSE_STYLE_REQUEST:
        case CREATE_WAREHOUSE_STYLE_REQUEST:
        case UPDATE_WAREHOUSE_STYLE_REQUEST:
        case DELETE_WAREHOUSE_STYLE_REQUEST:
        case FETCH_WAREHOUSE_STYLE_INVOICE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ALL_WAREHOUSE_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouseStyleData: updatePayload
            }
        case FETCH_BY_ID_WAREHOUSE_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    // fldFromDate: state.userform.fldFromDate,
                    // fldToDate: state.userform.fldToDate,
                }
            }
        case CREATE_USERFORM_WAREHOUSE_STYLE:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_WAREHOUSE_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    // fldFromDate: state.userform.fldFromDate,
                    // fldToDate: state.userform.fldToDate,
                },
                detailsId: updatePayload
            }
        case UPDATE_WAREHOUSE_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    // fldFromDate: state.userform.fldFromDate,
                    // fldToDate: state.userform.fldToDate,
                }
            }
        case DELETE_WAREHOUSE_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    // fldFromDate: state.userform.fldFromDate,
                    // fldToDate: state.userform.fldToDate,
                }
            }
        case FETCH_WAREHOUSE_STYLE_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                warehouseStyleInvoiceData: updatePayload
            }
        case FETCH_ALL_WAREHOUSE_STYLE_FAILURE:
        case FETCH_BY_ID_WAREHOUSE_STYLE_FAILURE:
        case CREATE_WAREHOUSE_STYLE_FAILURE:
        case UPDATE_WAREHOUSE_STYLE_FAILURE:
        case DELETE_WAREHOUSE_STYLE_FAILURE:
        case FETCH_WAREHOUSE_STYLE_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case RESET_WAREHOUSE_STYLE_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    // fldFromDate: new Date(),
                    // fldToDate: new Date().setDate(new Date().getDate() + 30),
                    fldNoofPcs: '',
                    fldTransportCharges: '',

                },
                activeKey: 1,
            };

        case NAVIGATE_WAREHOUSE_STYLE:
            return {
                ...state,
                isWarehouseStyle: false
            };

        case NAVIGATE_WAREHOUSE_STYLE_DETAILS:
            return {
                ...state,
                isWarehouseStyle: true,
                loading: false,
                warehouseStyleSelectedValue: updatePayload.warehouseStyleSelectedValue
            };

        case WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                },
                activeKey: 2,
            };
        case WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                },
                activeKey: 1,
            };
        case NAVIGATE_WAREHOUSE_STYLE_PRINT:
            return {
                ...state,
                isWarehouseStyle: false,
                loading: false,
                warehouseStyleSelectedValue: updatePayload.warehouseStyleSelectedValue
            }
        case RESET_WAREHOUSE_STYLE_INVOICE:
            return {
                ...state,
                warehouseStyleInvoiceData: []
            };

        default:
            return state;
    }
}